import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { PatientModel } from '@shared/models/rx-models/interfaces/patient-model';
import { DateOfBirthPipe } from '@shared/pipes/date-of-birth.pipe';
import { ShellQuery } from '@shared/store/shell/shell-query';

@Component({
	selector: 'rx-patient-read-only',
	templateUrl: './patient-read-only.component.html',
	styleUrls: ['./patient-read-only.component.scss']
})
export class PatientReadOnlyComponent implements OnChanges {
	@Input() patient: PatientModel;
	@Input() isEditButtonVisible: boolean;
	@Input() isClearButtonVisible: boolean;
	@Input() isButtonsVisible: boolean;
	@Input() maxPatientLastNameLength = 0;
	@Input() isIntuitiveFlow: boolean;
	@Input() regulatoryDOBMask: string | null = null;
	@Input() dateFormat: string;
	@Output() patientCleared = new EventEmitter<void>();
	@Output() patientEdited = new EventEmitter<void>();
	genderOption: number | undefined = undefined;
	dateOfBirthPipe: DateOfBirthPipe = new DateOfBirthPipe();

	constructor(
		private readonly shellQuery: ShellQuery,
		private readonly formBuilder: FormBuilder
	) {}

	get firstNameControl() {
		return this.formGroup.controls.FirstName;
	}
	get lastNameControl() {
		return this.formGroup.controls.LastName;
	}
	get dateOfBirthControl() {
		return this.formGroup.controls.DateOfBirth;
	}
	get chartNumberControl() {
		return this.formGroup.controls.ChartNumber;
	}

	formGroup = this.formBuilder.group({
		FirstName: [{ value: '', disabled: true }],
		LastName: [{ value: '', disabled: true }],
		DateOfBirth: [{ value: '', disabled: true }],
		ChartNumber: [{ value: '', disabled: true }]
	});

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	ngOnChanges(changes: SimpleChanges) {
		if (this.patient && this.regulatoryDOBMask !== null) {
			this.formGroup.patchValue({
				FirstName: this.patient.FirstName || '',
				LastName: this.patient.LastName || '',
				DateOfBirth: this.dateOfBirthPipe.transform(this.patient.DateOfBirth, this.shellQuery.dateFormat, this.regulatoryDOBMask),
				ChartNumber: this.patient.ChartNumber || ''
			});

			this.setMarkOnControl(this.dateOfBirthControl);
			this.setMarkOnControl(this.chartNumberControl);
			this.genderOption = this.patient.Gender;
		}
	}

	setMarkOnControl(control: FormControl) {
		if (!control.value) {
			control.patchValue(' ');
			control.markAsTouched();
		}
	}

	clearPatient(): void {
		this.patientCleared.next();
	}

	editPatient(): void {
		this.patientEdited.next();
	}
}
